import { FC } from 'react';

type Props = {
	className?: string;
};

const ArrowLeftIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M11.5 6L8.20711 9.29289C7.87377 9.62623 7.70711 9.79289 7.70711 10C7.70711 10.2071 7.87377 10.3738 8.20711 10.7071L11.5 14'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ArrowLeftIcon;
